import { createFileRoute } from '@tanstack/react-router';
import { FileKey2 } from 'lucide-react';
import { ComingSoonPage } from '@/components/sysadmin/coming-soon';

export const Route = createFileRoute('/sysadmin/platform/license')({
  component: () => (
    <ComingSoonPage
      icon={FileKey2}
      title="License"
      specRef="§3.8"
      wave="Phase 6"
      description="Tenant license tier management. Signed license file enumerates the seat count, GPU count cap, support tier, and feature toggle bundles permitted on this deployment. Enforcement is read-only against the license at API boot — runtime overrides come from the Settings rail's tier templates."
      bullets={[
        'License file viewer + Ed25519 integrity check',
        'Seat count rollup vs. licensed maximum + per-tenant breakdown',
        'GPU count cap matched against the hardware profile (Deployment)',
        'Support tier badge + expiry countdown',
        'Feature toggle entitlements (which toggles this license unlocks)',
        'Expiry alerts — 90d / 60d / 30d warnings routed to Settings → Notifications',
      ]}
    />
  ),
});
